import { useCallback, useEffect, useState } from 'react';
import api from '../lib/api';
import { logError } from '../lib/log';
import { useAuth } from '../context/AuthContext';

// Which guides the signed-in user has marked as read. Signed-out users get
// an empty set and no requests.
export const useReading = () => {
  const { user } = useAuth();
  const isAuthed = user && typeof user === 'object';
  const [slugs, setSlugs] = useState([]);
  const [total, setTotal] = useState(0);

  const refresh = useCallback(async () => {
    if (!isAuthed) {
      setSlugs([]);
      return;
    }
    try {
      const { data } = await api.get('/me/reading');
      setSlugs(data.slugs || []);
      setTotal(data.total || 0);
    } catch (e) { logError('useReading.refresh', e); }
  }, [isAuthed]);

  useEffect(() => { refresh(); }, [refresh]);

  const mark = useCallback(async (slug) => {
    await api.post(`/me/reading/${slug}`);
    setSlugs((list) => (list.includes(slug) ? list : [...list, slug]));
  }, []);

  const unmark = useCallback(async (slug) => {
    await api.delete(`/me/reading/${slug}`);
    setSlugs((list) => list.filter((s) => s !== slug));
  }, []);

  return { isAuthed, readSlugs: slugs, total, mark, unmark, refresh };
};

export default useReading;
